import React from "react";
import { useTranslation } from "react-i18next";
import format from "date-fns/format";
import parseJSON from "date-fns/parseJSON";

import { Transaction, Transfer } from "../../types";

import styles from "./InvalidationStatus.module.scss";

interface Props {
  transactionOrTransfer: Transaction | Transfer;
}

const InvalidationStatus = (props: Props) => {
  const {
    invalidatedBy,
    invalidationDate,
    invalidationReason,
  } = props.transactionOrTransfer;
  const { t } = useTranslation();

  const isInvalidationInfo = invalidationReason && invalidationDate;
  const date = parseJSON(invalidationDate || new Date().toJSON());
  const formattedDate = format(date, "dd MMM yyyy");
  const invalidatedByName = invalidatedBy
    ? invalidatedBy.displayName || t("transactions.details.undefinedUser")
    : undefined;

  return isInvalidationInfo ? (
    <div className={styles.invalidationInfo}>
      <span>
        {t(
          `transactions.details.invalidation.string${
            invalidatedBy ? "" : "External"
          }`,
          {
            date: formattedDate,
            username: invalidatedByName,
          }
        )}
      </span>
      <span>
        {t("transactions.details.invalidation.reason", {
          reason: invalidationReason,
        })}
      </span>
    </div>
  ) : null;
};

export default InvalidationStatus;
